import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import { AuthModule, AuthState } from '@/store/AuthModule';
import { PreferencesModule, PreferencesState } from '@/store/PreferencesModule';
import { DataModule, DataState } from '@/store/DataModule';
import { socketConnection, SocketState } from '@/store/socketConnection';
import { tour } from '@/store/tour';
import { socketAgencyConnection, SocketAgencyState } from '@/store/socketAgencyConnection';

export interface RootState {
  auth: AuthState;
  preferences: PreferencesState;
  data: DataState;
  socket: SocketState;
  socketAgency: SocketAgencyState;
}

const vuexLocal = new VuexPersistence<RootState>({
  storage: window.localStorage,
  modules: ['PreferencesModule'],
});

const vuexSession = new VuexPersistence<RootState>({
  storage: window.sessionStorage,
  modules: ['AuthModule', 'DataModule'],
});

Vue.use(Vuex);

export default new Vuex.Store<RootState>({
  modules: {
    AuthModule,
    PreferencesModule,
    DataModule,
    socketConnection,
    // socketAgencyConnection,
    tour,
  },
  plugins: [vuexLocal.plugin, vuexSession.plugin],
});
